// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"00664027","318":"d541381a","377":"2277411e","423":"a4729822","432":"d1d8e39b","508":"b9b981f6","591":"fcd4b17f","622":"3520671e","633":"b82b812d","725":"64d6ee49","727":"3691be34","734":"9ceb40ff"}[chunkId] + ".chunk.js";
};